module.exports = __webpack_public_path__ + "img/COM-i-1-III.affc118a.png";